import { Component, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ServiceReminderService } from 'src/app/_services/service-reminder.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CreateServiceReminderComponent } from './create-service-reminder/create-service-reminder.component';
import { ServiceDetailsComponent } from './service-details/service-details.component';
import { UpdateServiceReminderComponent } from './update-service-reminder/update-service-reminder.component';
import { MenuItem } from 'primeng/api';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IssuesService } from 'src/app/_services/issues.service';
import { ActiveIssueReportDialogComponent } from '../active-issues/active-issue-report-dialog/active-issue-report-dialog.component';
import { Table } from 'primeng/table';
@Component({
  selector: 'app-service-reminder',
  templateUrl: './service-reminder.component.html',
  styleUrls: ['./service-reminder.component.scss'],
})
export class ServiceReminderComponent implements OnInit {
  servcieReminders: any = [];
  ref: any;
  selectedCustomer: any;
  reminder: any;
  reminders$ = this.serviceReminderService.serviceReminders$;
  loading = false;
  position: string = 'center';
  visible: boolean = false;
  totalReminders: any;
  reminderData: any;
  currentFilter: any;
  currentPage: any;
  @ViewChild('signedOffIssuesTable') signedOffIssuesTable: Table | undefined;

  columns = [
    { field: 'vehicle_reference', header: 'Vehicle Reference' },
    { field: 'service_delta', header: 'KM Remaining' },
    { field: 'km_reading', header: 'KM Reading' },
    { field: 'service_due_date', header: 'Due Date' },
  ];

  items: MenuItem[] = [
    {
      label: 'Edit',
      icon: 'pi pi-pencil',
      command: () => this.updateReminder(this.selectedCustomer),
    },
    {
      label: 'Sign Off',
      icon: 'pi pi-check',
      command: () => this.signOffReminder(this.selectedCustomer),
    },
    {
      label: 'Delete',
      icon: 'pi pi-trash',
      command: () => this.deleteReminder(this.selectedCustomer),
    },
  ];

  constructor(
    private serviceReminderService: ServiceReminderService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public issuesService: IssuesService
  ) {}

  loadServiceReminders(event: any) {
    this.loading = true;

    const page = Math.floor(event.first / event.rows) + 1;
    const rows = event.rows;

    this.currentPage = event.first;

    this.serviceReminderService
      .getReminders(page, rows, this.currentFilter)
      .subscribe((data) => {
        console.log('SERVICE REMINDER',data);
        

        this.reminderData = data.body.service_reminders;
        this.loading = false;
        this.totalReminders = data.body.total_reminders;
      });
  }

  ngOnInit(): void {
    this.loadServiceReminders({ first: 0, rows: 100 });
  }

  getNumberofColumns() {
    return this.columns.length;
  }

  searchValue = '';

  filterGlobal(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.searchValue = inputElement.value.trim();
    this.currentFilter = this.searchValue;
    this.loadServiceReminders({ first: 0, rows: 100 });
  }

  clearSearch() {
    this.searchValue = '';
    this.currentFilter = '';
    this.loadServiceReminders({ first: 0, rows: 100 });
  }

  storeRowDetail(rowData: any) {
    this.selectedCustomer = rowData;
  }

  showCreateServiceReminder() {
    this.ref = this.dialogService.open(CreateServiceReminderComponent, {
      header: 'Create Service Reminder',
      width: '70%',
      styleClass: 'update-record-dialog-shell',
    });

    this.ref.onClose.subscribe((data: any) => {
      // console.log('Data', data);

      if (data) {
        this.loadServiceReminders({ first: this.currentPage, rows: 100 });
      }
    });
  }

  // showServiceDetails(data: any) {
  //   this.ref = this.dialogService.open(ServiceDetailsComponent, {
  //     header: 'Service Details',
  //     width: '85%',
  //     data: data,
  //   });
  // }

  updateReminder(reminder: any) {
    this.ref = this.dialogService.open(UpdateServiceReminderComponent, {
      header: 'Update Service Reminder',
      width: '70%',
      styleClass: 'update-record-dialog-shell',
      data: reminder,
    });

    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.loadServiceReminders({ first: this.currentPage, rows: 5 });
      }
    });
  }

  deleteReminder(reminder: any) {
    this.confirmationService.confirm({
      key: 'service_reminder',
      message: 'Are you sure that you want to delete this reminder?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.serviceReminderService
          .deleteReminder(reminder.id)
          .subscribe(() => {
            this.loadServiceReminders({ first: this.currentPage, rows: 100 });
          });
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Service reminder deleted',
          key: 'service_reminder',
        });
      }
    });
  }

  signOffReminder(reminder: any) {
    this.confirmationService.confirm({
      key: 'service_reminder',
      message: 'Are you sure that you want to sign off this reminder?',
      header: 'Sign Off Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.serviceReminderService
          .signOffReminder(reminder.id)
          .subscribe(() => {
            this.loadServiceReminders({ first: this.currentPage, rows: 100 });
          });
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Service reminder signed off',
          key: 'service_reminder',
        });
      }
    });
  }

  generate_excel_report() {
    this.issuesService.getIssueReport();
  }

  generate_csv_report() {
    this.issuesService.getCsvReport();
  }

  showReportDialog() {
    this.ref = this.dialogService.open(ActiveIssueReportDialogComponent, {
      header: 'Reporting',
      width: '60%',
      height: '35%',
      closeOnEscape: true,
    });
  }

  showDialog(position: string) {
    this.position = position;
    this.visible = true;
  }
}
